import BadgeRecommended from './BadgeRecommended';
import { selectIcon } from '../templates/place';
import { formatRecommendedDisplayType, createPlace } from './AutoCompleteSelect/displayTypes';
import useWidgetConfig from '../context/WidgetConfig';

const RouteOption = ({
  showRecommendedIcon,
  showRecommendedBadge,
  route,
  onSelect,
  showOrigin,
}) => {
  const { origin, destination } = route;
  const { displayType } = useWidgetConfig();

  const handleOnSelect = () => {
    const { origin, destination } = route;

    if (!origin && destination) {
      route.field = 'destination';
    }
    onSelect(route);
  };

  let originText,
    destinationText = '';

  if (showOrigin) {
    const originPlace = createPlace(origin);
    originText = formatRecommendedDisplayType(originPlace, displayType);
  }
  const destinationPlace = createPlace(destination);
  destinationText = formatRecommendedDisplayType(destinationPlace, displayType);

  const icons = icon => {
    return (
      <div
        className="route-icon"
        // eslint-disable-next-line react/no-danger
        dangerouslySetInnerHTML={{
          __html: selectIcon(icon, false),
        }}
      />
    );
  };

  return (
    <div className="route-option" onClick={handleOnSelect}>
      <div className="route-option-wrapper">
        {icons(showRecommendedIcon ? 'sparkle' : 'recent')}

        <div className="route-option-route">
          {showOrigin && <p className="route-option-terminal">{originText}</p>}
          <p className="route-option-terminal">{destinationText}</p>
        </div>
      </div>

      {showRecommendedBadge && <BadgeRecommended />}
    </div>
  );
};

export default RouteOption;
